
export const GET_HOMEPOST_REQUEST = "GET_HOMEPOST_REQUEST";
export const GET_HOMEPOST_SUCCESS = "GET_HOMEPOST_SUCCESS";
export const GET_HOMEPOST_FAILURE = "GET_HOMEPOST_FAILURE";